import { render, staticRenderFns } from "./LeClubButton.vue?vue&type=template&id=3c6984b7&"
import script from "./LeClubButton.vue?vue&type=script&lang=js&"
export * from "./LeClubButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports